import { Component } from '@angular/core';
import { NavbarV3Component } from '../../../components/layout/navbar-v3/navbar-v3.component';
import { FooterV3Component } from '../../../components/layout/footer-v3/footer-v3.component';

/** v3 page frame: theme root, navbar, <main>, footer. Routes using it set `data: { hideShell: true }`. */
@Component({
  selector: 'app-page-shell-v3',
  standalone: true,
  imports: [NavbarV3Component, FooterV3Component],
  template: `
    <div class="cp-root flex min-h-[100dvh] flex-col">
      <app-navbar-v3 />
      <main class="flex-1"><ng-content /></main>
      <app-footer-v3 />
    </div>
  `,
})
export class PageShellV3Component {}
